import React from "react";
import { QuoteIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { testimonials } from "../../data/content";
export function TestimonialsSection() {
  return <section className="bg-white px-5 py-16 sm:py-24" aria-label="Professional feedback" data-id="element-327" data-mp="1rtuwl4z28xgo">
      <div className="mx-auto max-w-5xl" data-id="element-328" data-mp="1mw1r6e5l07hg">
        <SectionHeading eyebrow="Professional feedback" title="What Early Users Say About the System" data-id="element-329" data-mp="1iuzr5v3ubref" />

        <ul className="mt-12 grid gap-6 md:grid-cols-2" data-id="element-330" data-mp="1dw6c3y8wnsc5">
          {testimonials.map(t => <li key={t.name} className="flex flex-col rounded-3xl bg-cream p-6 sm:p-8" data-id="element-331" data-mp="18wjy3ml9682a">
              <QuoteIcon className="h-8 w-8 text-brand/40" aria-hidden="true" data-id="element-332" data-mp="13xqj1pqbi900" />
              <blockquote className="mt-3 flex-1 text-[17px] leading-relaxed text-ink" data-id="element-333" data-mp="13ztjl3p3jkiz">“{t.quote}”</blockquote>
              <div className="mt-6 flex items-center gap-4 border-t border-ink/10 pt-5" data-id="element-334" data-mp="338gvdw6dm859">
                <img src={t.photo} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-2 ring-white shadow" loading="lazy" data-id="element-335" data-mp="2y9ndlrk23uza" />
                <div data-id="element-336" data-mp="1jbz8zbcrkgv6">
                  <p className="font-bold text-ink" data-id="element-337" data-mp="1jciqiqyi538o">{t.name}</p>
                  <p className="text-sm text-ink/60" data-id="element-338" data-mp="1oak6v44jmogg">{t.role}</p>
                </div>
              </div>
            </li>)}
        </ul>

        <div className="mt-12" data-id="element-339" data-mp="2c1fx3wtcpbll">
          <CtaButton label="I want the same organized system" data-id="element-340" data-mp="2c2h9q5q0m65f" />
        </div>
      </div>
    </section>;
}